<template>
  <nav
    v-show="currentHandle === handle"
  
    class="mega-menu js-mega-menu critical-component-hide"
    :class="{ [$class('active')]: currentHandle === handle,
              'mega-menu__has-row': blocks?.type === 'content_row',
              'mega-menu__has-blocks': blocks?.type === 'content_blocks',
    }"
  >
    <div class="mega-menu__container container">
      <!-- Row content -->
      <div
        v-if="blocks?.type === 'content_row'"
        class="mega-menu__row"
      >
        <div
          v-if="blocks.title"
          class="mega-menu__row-heading text-heading-s"
          v-text="blocks.title"
        />

        <div class="mega-menu__row-container">
          <template
            v-for="(block) of blocks.content"
            :key="block.handle"
          >
            <a
              class="mega-menu__row-block"
              :href="block.url"
            >
              <div
                class="mega-menu__row-block-image"
              >
                <responsive-image

                  :image="block.desktopImage"
                  :lazyload="false"
                  ratio="1:1"
                  widths="120, 160, 200, 240, 320, 400"
                />
              </div>

              <div
                class="mega-menu__row-block-title text-body-m-bold"
                v-text="block.title"
              />

  <div
    v-if="block.subtitle"
    class="mega-menu__row-block-subtitle"
    v-text="block.subtitle"
  />



            </a>
          </template>
        </div>
      </div>

      <divider-line v-if="blocks?.type === 'content_row'" />
      <!-- Block content -->
      <div
        v-if="blocks?.type === 'content_blocks'"
        class="mega-menu__blocks"
      >
        <template
          v-for="(block) of blocks.content"
          :key="block.handle"
        >
          <a
            class="mega-menu__content-block"
            :class="blockContentStyles(block)"
            :href="block.url"
          >
            <div
              class="mega-menu__content-block-image"
            >
              <responsive-image
                :padding="!block.bgImage"
                :image="block.desktopImage"
                :lazyload="false"
                ratio="14:15"
                widths="120, 160, 200, 240, 320, 400"
              />
            </div>

            <div class="mega-menu__content-block-copy">
              <span
                v-if="block.eyebrow"
                class="
                  mega-menu__content-block-text
                  mega-menu__content-block-eyebrow text-body-xs-regular
                "
                v-text="block.eyebrow"
              />
              <span
                v-if="block.title"
                class="
                  mega-menu__content-block-text
                  mega-menu__content-block-title
                "
                :class="titleClass(block)"
                v-text="block.title"
              />
              <span
                v-if="block.startPrice"
                class="
                  mega-menu__content-block-text
                  mega-menu__content-block-start-price text-body-xs-regular
                "
                v-text="$string(
                  'general.site_header.starting',
                  {
                    replace: { price: block.startPrice },
                  },
                )"
              />
              <btn
                v-if="block.ctaText"
                class="
                  mega-menu__content-block-text
                  mega-menu__content-block-cta-text
                "
                :label="block.ctaText"
                show-icon
                modifiers="text"
              />
            </div>
          </a>
        </template>
      </div>

      <!-- Main megu menu -->
      <ul
        :class="{
          'mega-menu__menus': isMultiList,
          'mega-menu__single-menu': !isMultiList,
        }"
      >
        <template
          v-for="(menu) of menuLinks.links"
          :key="menu.handle"
        >
          <li class="mega-menu__item">
            <ul
              v-if="menu.links?.length"
              class="mega-menu__list"
              :class="{
                'mega-menu__list--2-columns': menu.title.toLowerCase()
                  .includes('by taste')
              }"
            >
              <li class="mega-menu__item-tier mega-menu__item--title">
                <span
                  class="mega-menu__title text-heading-s"
                  v-text="menu.title"
                />
              </li>

              <li
                v-for="(link) of menu.links"
                :key="link.handle"
                class="mega-menu__item-tier"
              >
                <a
                  class="
                    mega-menu__link
                    text-body-s-regular
                  "
                  :href="link.url"
                  v-text="link.title"
                />
              </li>
            </ul>

            <a
              v-else
              class="mega-menu__link text-body-s-regular"
              :href="menu.url"
              v-text="menu.title"
            />
          </li>
        </template>
      </ul>
    </div>
  </nav>
</template>

<script>

/**
 * Vue: Mega menu (mega-menu)
 * -----------------------------------------------------------------------------
 * Mega menu.
 * - Component settings: snippet / dynamic / async / scroll
 *
 */
import ResponsiveImage from '~global/images/responsive-image'
import Btn from '~global/btn/btn'
import DividerLine from '~async/utils/divider-line/divider-line'

export default {
  name: 'MegaMenu',

  components: {
    Btn,
    DividerLine,
    ResponsiveImage,
  },

  props: {
    blocks: {
      type: [Boolean, Object],
      default: () => false,
    },
    handle: {
      type: String,
      default: '',
    },
    currentHandle: {
      type: String,
      default: '',
    },
    menuLinks: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: {
    'update-mega-menu': () => true,
  },

  data() {
    return {}
  },

  computed: {
    isMultiList() {
      const findTier2 = this.menuLinks?.links.find((links) => {
        return links.links.length > 0
      })

      return findTier2
    },
  },

  mounted() {
    this.$emit('update-mega-menu')
  },

  methods: {

    /**
     * Get block content styles
     * @param {Object} block - block content.
     * @returns {String}
     */
    blockContentStyles(block) {
      let blockStyles = ''
      if (block.lightText) {
        blockStyles = 'light'
      }

      if (block.gradient) {
        blockStyles += ' gradient-overlay'
      }

      if (block.bgImage) {
        blockStyles += ' bg-image'
      }

      return blockStyles
    },

    /**
     * Get title class
     * @param {Object} block - block content.
     * @returns {String}
     */
    titleClass(block) {
      let textClass = 'text-body-l-bold'

      if (block.bgImage) {
        textClass = 'text-body-m-bold'
      }

      return textClass
    },
  },
}
</script>

<style lang="scss">
@import './mega-menu';
</style>
